<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs :breadcrumbstitle="breadcrumbstitle" :breadcrumbsData="breadcrumbsData"/>
      <div class="content mt-3">
        <div class="animated fadeIn" v-if="this.hasRole">
          <!-- content place -->


          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('company.title')}}</strong>
                <div class="float-right">
                  <router-link :to="{ path: '/companies'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('companies.title')}}</router-link>
                  &nbsp;
                  <template v-if="$store.state.usercompanies&&$store.state.usercompanies.length<1">
                    <span class="btn btn-primary btn-sm" v-on:click="emptyForNew()"><i class="fa fa-link"></i> {{$t('company.new')}}</span>
                  </template>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-success btn-sm" v-on:click="save()">
                  <i class="fa fa-save"></i> {{$t('global.save')}}
                </button>
              </div>

              <div class="card-body card-block">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :msgPre="AlertInPage.msgPre" :msgPost="AlertInPage.msgPost" :delay="AlertInPage.delay"/>
                <!--<AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>-->
                <!--<AlertInPage />-->
                <!--<AlertInPage type="success" msg="msg" delay="2000"/>-->
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="name" class=" form-control-label">{{ $t('company.companyname') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.name" type="text" id="name" placeholder="" class="form-control" name="data.name"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.name')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumber" class=" form-control-label">{{ $t('company.taxnumber') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.taxnumber" type="text" id="taxnumber" placeholder="" class="form-control" name="data.taxnumber"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.taxnumber')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumbercountrygroup" class=" form-control-label">{{ $t('company.taxnumbercountrygroup') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.taxnumbercountrygroup" type="text" id="taxnumbercountrygroup" placeholder="" class="form-control" name="data.taxnumbercountrygroup"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.taxnumbercountrygroup')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumberother" class=" form-control-label">{{ $t('company.taxnumberother') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.taxnumberother" type="text" id="taxnumberother" placeholder="" class="form-control" name="data.taxnumberother"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.taxnumberother')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="registrationnumber" class=" form-control-label">{{ $t('company.registrationnumber') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.registrationnumber" type="text" id="registrationnumber" placeholder="" class="form-control" name="data.registrationnumber"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.registrationnumber')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="bank_account" class=" form-control-label">{{ $t('company.bank_account') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.bank_account" type="text" id="bank_account" placeholder="" class="form-control" name="data.bank_account"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.bank_account')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="dt" class=" form-control-label">{{ $t('company.dt') }} ({{ $t('validator.required') }})</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<input v-model="data.dt" type="text" id="dt" placeholder="" class="form-control" name="data.dt"-->
                  <!--v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.dt')}">-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="country" class=" form-control-label">{{ $t('company.country') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.country" type="text" id="country" placeholder="" class="form-control" name="data.country"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.country')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="county" class=" form-control-label">{{ $t('company.county') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.county" type="text" id="county" placeholder="" class="form-control" name="data.county"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.county')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="zip" class=" form-control-label">{{ $t('company.zip') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.zip" type="text" id="zip" placeholder="" class="form-control" name="data.zip"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.zip')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="city" class=" form-control-label">{{ $t('company.city') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.city" type="text" id="city" placeholder="" class="form-control" name="data.city"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.city')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="public_space" class=" form-control-label">{{ $t('company.public_space') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.public_space" type="text" id="public_space" placeholder="" class="form-control" name="data.public_space"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.public_space')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="nature_of_public_space" class=" form-control-label">{{ $t('company.nature_of_public_space') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.nature_of_public_space" type="text" id="nature_of_public_space" placeholder="" class="form-control" name="data.nature_of_public_space"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.nature_of_public_space')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="house_number" class=" form-control-label">{{ $t('company.house_number') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.house_number" type="text" id="house_number" placeholder="" class="form-control" name="data.house_number"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.house_number')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="building" class=" form-control-label">{{ $t('company.building') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.building" type="text" id="building" placeholder="" class="form-control" name="data.building"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.building')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="staircase" class=" form-control-label">{{ $t('company.staircase') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.staircase" type="text" id="staircase" placeholder="" class="form-control" name="data.staircase"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.staircase')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="floor" class=" form-control-label">{{ $t('company.floor') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.floor" type="text" id="floor" placeholder="" class="form-control" name="data.floor"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.floor')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="door" class=" form-control-label">{{ $t('company.door') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.door" type="text" id="door" placeholder="" class="form-control" name="data.door"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.door')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="phone_def" class=" form-control-label">{{ $t('company.phone_def') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.phone_def" type="text" id="phone_def" placeholder="" class="form-control" name="data.phone_def"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.phone_def')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="email_def" class=" form-control-label">{{ $t('company.email_def') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.email_def" type="text" id="email_def" placeholder="" class="form-control" name="data.email_def"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.email_def')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                    <div class="row form-group">
                      <div class="col col-md-3"><label for="autonav" class=" form-control-label">{{ $t('company.autonav') }}</label></div>
                      <div class="col-12 col-md-9">
                        <select class="form-control" id="autonav" v-model="data.autonav" name="data.autonav">
                          <option value="0">{{$t('global.no')}} </option>
                          <option value="1">{{$t('global.yes')}}</option>
                        </select>
                      </div>
                    </div>

                  <hr>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="deleted" class=" form-control-label">{{ $t('global.deleted') }}</label></div>
                    <div class="col-12 col-md-9">
                      <select class="form-control" id="deleted" v-model="data.deleted" name="data.deleted">
                        <option value="0">{{$t('global.no')}} </option>
                        <option value="1">{{$t('global.yes')}}</option>
                      </select>
                    </div>
                  </div>

                </form>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-success btn-sm" v-on:click="save()">
                  <i class="fa fa-save"></i> {{$t('global.save')}}
                </button>
              </div>
            </div>

          </div>


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>

</template>

<script>

  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';
  import BarcodeGenerator from '@/components/BarcodeGenerator.vue';
  import JsBarcode from 'jsbarcode';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Api from '@/api/Api';


  //  id_store 	wsid 	text
  export default {
    name: 'SelVat',
    data() {
      return {
        moduleRights: []
        , moduleRightsIds: []
        , roles: []
        , user_role: 0
        , Helper: Helper
        ,

        data: {
          // cardinality 	vat_text 	deleted
          "id": "",
          "deleted": "0",
        }
        , dataBase: { // need for change without save
          "id": "",
          "deleted": "0",
        }
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }
        , breadcrumbstitle: 'company.title'
        , breadcrumbsData: [
          {
            'title': "companies.title",
            'url': "companies",
          },
          {
            'title': "company.title",
          }
        ]
        , barcode: ""
        , hasRole: false
        , advancedfeatures: false

      };
    },
    props: {
      id: String,
    },
    watch: {
      '$store.state.user': function (newVal, oldVal) {
        const modul = this;
        modul.handleRights();
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          modul.getMyCompany();
        }
      },
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        console.log("healthCheckHash");
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          if (modul.state && modul.state.settings && modul.state.settings.advancedfeatures) {
            modul.advancedfeatures = modul.state.settings.advancedfeatures === "true";
          }
          modul.handleRights();
//          this.getElement();
        }
      },

//      '$store.state.user': function (newVal, oldVal) {
//        const modul = this;
//        modul.hasRole = Helper.checkRolesAuto(this, [3, 6, 8, 11], 14);
//      },
//      '$store.state.moduleRights': function (newVal, oldVal) {
//        const modul = this;
//        modul.hasRole = Helper.checkRolesAuto(this, [3, 6, 8, 11], 14);
//      },


//      '$route.params': function (newdata, olddata) {
//        if (this.$route.params.id) {
//          this.id = newdata;
//        } else {
//          this.id = void 0;
//        }
//        this.getMyCompany();
//      }
    },
    mounted() {
      const modul = this;
      console.log("company");
//      modul.hasRole = true; // Helper.checkRolesAuto(this, [3,6,8,11],14);
      modul.handleRights();
      if (modul.state && modul.state.settings && modul.state.settings.advancedfeatures) {
        modul.advancedfeatures = modul.state.settings.advancedfeatures === "true";
      }
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (modul.$store.state.user && modul.$store.state.user.role === "ADMIN") {
          modul.hasRole = true;
        }
      },

      getMyCompany(){
        const modul = this;
        let id = 0;
        try {
          id = (this.$route.params.id);
          if (id) {
            const alertId = Math.random();
            modul.$eventBus.$emit('globalAlert', {
              id: alertId,
              type: "warning",
              msgPreInner: "",
              msg: "form.in_progress",
              msgPostInner: "",
              delay: 50000
            });

            Api.getMyCompany({id: id, id_company: modul.$store.state.id_company}).then(function (res) {
              console.log(res);
              modul.$eventBus.$emit('globalAlert', {
                id_delete: alertId,
//                  type: "success",
//                  msgPreInner: "",
//                  msg: "form.succes",
//                  msgPostInner: "",
//                  delay: 1000
              });
              if (res && res.result) {
                modul.data = res.data;
                modul.$eventBus.$emit('globalAlert', {
                  id_delete: alertId,
//                  type: "success",
//                  msgPreInner: "",
//                  msg: "form.succes",
//                  msgPostInner: "",
//                  delay: 1000
                });

              } else {
                modul.$eventBus.$emit('globalAlert', {
                  id_delete: alertId,
                  type: "danger",
                  msgPreInner: "",
                  msg: "form.error",
                  msgPostInner: "",
                  delay: 5000
                });

              }
            });
          }
        } catch (e) {
          console.log(e);
        }
      },
      emptyForNew(){
        const modul = this;
        modul.data = Object.assign({}, modul.dataBase);
        modul.$router.push({name: "emptypage"});
        setTimeout(function () {
          modul.$router.push({path: "/company"})
        }, 300);
      },
      save(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const data = Helper.makeFilteredObjectByKeys(modul.data, ["id", "name", "taxnumber", "taxnumbercountrygroup", "taxnumberother", "registrationnumber", "bank_account", "dt", "zip", "public_space", "nature_of_public_space", "house_number", "building", "staircase", "floor", "door", "county", "city", "country", "phone_def", "email_def", "deleted", "autonav"]);
            const req = {};
            req.data = data;
            req.id = "";
            req.id_company = modul.$store.state.id_company;
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.saveMyCompany(req).then(function (res) {
              if (res && res.result) {
                if (res && res.data) {
                  modul.data = res.data;
                }
//                if (res && res.data.id) {
//                  modul.data.id = res.data.id;
//                }
                modul.AlertInPage.msg = "form.save_succes";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                  modul.$router.push({path: "/companies"})
                }, Number(modul.AlertInPage.delay));
                modul.$eventBus.$emit('HealthChecker', {command: "do"});
              } else {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              }
            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
          }
        });
      }
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      BarcodeGenerator,
      MenuToggle
    },
  };
</script>








